module.exports = __webpack_public_path__ + "img/lx.30c77e80.png";